import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {UserService} from 'api/user'

import {Loading} from 'ui'
import {Form, Input, Submit, Reset} from 'forms'

import {PhoneInput} from './PhoneInput.jsx'
import {PasswordStrength, scorePassword} from './PasswordStrength.jsx'

export class Account extends React.Component {
   static get propTypes() {
      return {
         user: React.PropTypes.object
      }
   }

   constructor(props) {
      super(props)

      this.state = {
         notify: null
      }
   }

   componentWillMount() {
      this._mounted = true
   }

   componentWillUnmount() {
      this._mounted = false
   }

   dismissNotification() {
      this.setState({notify: null})
   }

   validatePw(pw, {param}, input, patch) {
      if ('password' === param && !pw && !patch.$password) {
         return true
      }

      // validate that passwords match
      if ('$password' === param && pw !== patch.password) {
         return '' === patch.password ? true : {error: 'Password does not match'}
      } else {
         const score = scorePassword(pw)

         if (!pw) {
            return true
         }

         if (30 > score) {
            return {error: 'Password is to weak', score}
         }

         if (8 > pw.length) {
            return {error: 'Password should be atleast 8 characters long', score}
         }

         return {score}
      }
   }

   handleSubmit(ev, newdata) {
      ev.preventDefault()

      return UserService.update(newdata)
   }

   render() {
      let {user} = this.props

      const transform = data => _.omit(data, '$password')

      if (!user) {
         user = {}
      }

      return (
         <div>
            <div className="page-header">
               <h1>Account Settings</h1>
            </div>

            <Loading loading={_.eq({}, user)}>
               <Form transform={transform} input={user} onSubmit={this.handleSubmit}>

                  <Form.Updated>
                     Success! Your user details where updated!
                  </Form.Updated>

                  <Form.Error>
                     Unfortunately an error occured and we where not able to update
                     your user.<br /><br />
                  </Form.Error>

                  <div className="subtitle">
                     <h3>User Information</h3>
                  </div>

                  <Row>
                     <Col xs={12} sm={6}>
                        <label>Email</label>
                        <p className="form-control-static">{user.email}</p>
                     </Col>

                     <Col xs={12} sm={6}>
                        <Input param="name" label="Full Name" validate={{size: 48}} type="text" />
                     </Col>

                     <Col xs={12} sm={6}>
                        <PhoneInput param="phone" />
                     </Col>
                  </Row>

                  <div className="subtitle">
                     <h3>Security</h3>
                  </div>

                  <Row>
                     <Col xs={12} sm={6}>
                        <Input
                           param="password"
                           type="password"
                           label="Password"
                           validate={this.validatePw}
                           feedback={props => <PasswordStrength score={5} {...props} />}
                        />
                     </Col>

                     <Col xs={12} sm={6}>
                        <Input
                           param="$password"
                           type="password"
                           label="Confirm Password"
                           validate={this.validatePw}
                           disabled={false}
                        />
                     </Col>
                  </Row>

                  <Row style={{marginBottom: '20px', marginTop: '1rem'}}>
                     <Col xs={12}>
                        <div className="text-right">
                           <Submit>Update Account</Submit>
                           <Reset>Reset Form</Reset>
                        </div>
                     </Col>
                  </Row>
               </Form>
            </Loading>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/user/account/index.jsx